import { render, staticRenderFns } from "./cmprotinastarefa.vue?vue&type=template&id=70dd3b87&"
import script from "./cmprotinastarefa.vue?vue&type=script&lang=js&"
export * from "./cmprotinastarefa.vue?vue&type=script&lang=js&"
import style0 from "./cmprotinastarefa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports